const nav = {
	init: () => {
		nav.setBodyClassByWindowPosition();
		nav.initScrollListener();
		nav.initHamburger();

		nav.initDataHrefLink();
	},
	initDataHrefLink: () => {
		const links = document.querySelectorAll(`[data-href]`);
		links.forEach((link) => {
		    link.addEventListener('click', (ev) => {
				ev.preventDefault();
				ev.stopPropagation();

				window.location.href = link.getAttribute('data-href');
			})
		})
	},

	initScrollListener: () => {
		window.addEventListener('scroll', () => {
			nav.setBodyClassByWindowPosition();
		})
	},
	setBodyClassByWindowPosition: () => {
		document.body.classList.toggle('body-is-scrolled', (window.scrollY > 0));
	},
	initHamburger: () => {
		const hamburgers = document.querySelectorAll(`[data-hamburger]`);
		hamburgers.forEach((hamburger) => {
		    hamburger.addEventListener('click', (ev) => {
				ev.preventDefault();
				document.body.classList.toggle('hamburger-is-active');
			})
		})
	}
}

export default nav;
